import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh-system",
  "use": "icon-refresh-system-usage",
  "viewBox": "0 0 14.366 14.117",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.366 14.117\" id=\"icon-refresh-system\">\n  <path id=\"icon-refresh-system_路径_18032\" data-name=\"路径 18032\" d=\"M7.221,14.117A7.12,7.12,0,0,1,5.712.04L6.054,1.6a5.516,5.516,0,1,0,2.37,0L8.765.04A7.12,7.12,0,0,1,7.221,14.117ZM0,0H6.057V5.965Z\" fill=\"#feb80f\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol